
import BaolinDashboard from "./views/BaolinPrivate/BaolinDashboard";
import VegeFestDashboard from "./views/BaolinPrivate/VegeFestDashboard";
import ChingMingDashboard from "./views/BaolinPrivate/ChingMingDashboard";
import BudhaBathDashboard from "./views/BaolinPrivate/BudhaBathDashboard";
import Buttons from "views/Components/Buttons.js";
import GridSystem from "views/Components/GridSystem.js";
import Panels from "views/Components/Panels.js";
import SweetAlert from "views/Components/SweetAlertPage.js";
import Notifications from "views/Components/Notifications.js";
import Icons from "views/Components/Icons.js";
import Typography from "views/Components/Typography.js";
import RegularForms from "views/Forms/RegularForms.js";
import ExtendedForms from "views/Forms/ExtendedForms.js";
import ValidationForms from "views/Forms/ValidationForms.js";
import Wizard from "views/Forms/Wizard/Wizard.js";
import RegularTables from "views/Tables/RegularTables.js";
import ExtendedTables from "views/Tables/ExtendedTables.js";
import ReactTables from "views/Tables/ReactTables.js";
import GoogleMaps from "views/Maps/GoogleMaps.js";
import FullScreenMap from "views/Maps/FullScreenMap.js";
import VectorMap from "views/Maps/VectorMap.js";
import Charts from "views/Charts.js";
import Calendar from "views/Calendar.js";
import UserPage from "views/Pages/UserPage.js";
import LoginPage from "views/Pages/private/LoginPage";
import RegisterPage from "views/Pages/RegisterPage.js";
import LockScreenPage from "views/Pages/LockScreenPage.js";
import EventRegAdmin from "./views/BaolinPrivate/EventRegAdmin";
import VegeFestRegAdmin from "./views/BaolinPrivate/VegeFestRegAdmin";


import SutraTranslator from "views/BaolinPrivate/SutraTranslator";
import AdminUserMgmt from "views/BaolinPrivate/AdminUserMgmt";

var routes = [
  {
    path: "/dashboard",
    layout: "/admin",
    name: "Budha Bath Dashboard",
    icon: "nc-icon nc-chart-pie-35",
    component: BudhaBathDashboard
  },
  {
    path: "/EventRegAdmin",
    layout: "/admin",
    name: "Events",
    icon: "nc-icon nc-notification-70",
    component: VegeFestRegAdmin
  },
  // {
  //   path: "/volunter",
  //   layout: "/admin",
  //   name: "Volunteering",
  //   icon: "nc-icon nc-settings-tool-66",
  //   component: Calendar
  // },
  {
    collapse: true,
    path: "/components",
    name: "Tools",
    state: "openTools",
    icon: "nc-icon nc-app",
    views: [
      {
        path: "/sutratranslator",
        layout: "/admin",
        name: "Translator",
        mini: "TX",
        component: SutraTranslator
      }
    ]
  },
  {
    collapse: true,
    path: "/components",
    name: "Administration",
    state: "openAdministration",
    icon: "nc-icon nc-single-02",
    views: [
      {
        path: "/adminusermgmt",
        layout: "/admin",
        name: "User Management",
        mini: "U",
        component: AdminUserMgmt
      }
    ]
  }
];
export default routes;
